const ANALYTICS_CONSENT_KEY = 'whe2_analytics_consent';
const ANALYTICS_CHANGED_EVENT = 'whe2:analytics-consent-changed';
const GOOGLE_ANALYTICS_ID = 'G-0VS36GZSPC';

const canUseBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';

export const getAnalyticsConsent = () => {
  if (!canUseBrowser()) {
    return null;
  }

  return window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
};

export const hasAnalyticsConsent = () => getAnalyticsConsent() === 'granted';

export const setAnalyticsConsent = (value) => {
  if (!canUseBrowser()) {
    return;
  }

  window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  window.dispatchEvent(new CustomEvent(ANALYTICS_CHANGED_EVENT, { detail: value }));

  if (value === 'granted') {
    enableAnalytics();
  }
};

const loadGoogleAnalytics = () => {
  if (!canUseBrowser() || window.__whe2GoogleAnalyticsLoaded) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GOOGLE_ANALYTICS_ID, { anonymize_ip: true });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
  script.dataset.whe2Analytics = 'google';
  document.head.appendChild(script);

  window.__whe2GoogleAnalyticsLoaded = true;
};

const loadVercelAnalytics = () => {
  if (!canUseBrowser() || window.__whe2VercelAnalyticsLoaded) {
    return;
  }

  if (!window.location.hostname.includes('vercel.app')) {
    window.__whe2VercelAnalyticsLoaded = true;
    return;
  }

  const script = document.createElement('script');
  script.src = '/_vercel/insights/script.js';
  script.defer = true;
  script.dataset.whe2Analytics = 'vercel';
  document.head.appendChild(script);

  window.__whe2VercelAnalyticsLoaded = true;
};

export const enableAnalytics = () => {
  if (!hasAnalyticsConsent()) {
    return;
  }

  loadGoogleAnalytics();
  loadVercelAnalytics();
};

export const subscribeToAnalyticsConsent = (callback) => {
  if (!canUseBrowser()) {
    return () => {};
  }

  const handleChange = (event) => callback(event.detail ?? getAnalyticsConsent());
  window.addEventListener(ANALYTICS_CHANGED_EVENT, handleChange);

  return () => {
    window.removeEventListener(ANALYTICS_CHANGED_EVENT, handleChange);
  };
};
